"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.get = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var imports_1 = require("@lib/imports");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageMenuMain_sidecar_1 = require("@voyage/ui/voyageMenuMain-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        createButtons();
        exports.setOpen(false);
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 600;
    var th = 700;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiMessage);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        isRefreshing: false,
        buttonsGames: [],
        lastListLength: 0,
    });
    // voyageUiCanvas
    // obj.buttons = [
    //   voyageUiGButtons.create('Ok', 50, 50, () => {
    //     get().onOk()
    //     setOpen(false)
    //   }),
    // ]
    return obj;
};
var createButtons = function () {
    var obj = get();
    obj.buttons = [
        voyageUiGButtons_sidecar_1.voyageUiGButtons.create('Cancel', 50, 50, function () {
            exports.setOpen(false);
        }),
        voyageUiGButtons_sidecar_1.voyageUiGButtons.create('Refresh', 250, 50, function () {
            obj.isRefreshing = true;
        }),
    ];
    var list = websockets_sidecar_1.websockets.getGameList();
    var x = 0;
    var y = 0;
    imports_1.l.forEach(list, function (c) {
        obj.buttons.push(voyageUiGButtons_sidecar_1.voyageUiGButtons.create(c.key + ' (' + c.numPlayers + ')', x, y, function () {
            exports.setOpen(false);
            voyageMenuMain_sidecar_1.voyageMenuMain.setOpen(false);
            voyageMenuMain_sidecar_1.voyageMenuMain.setBackgroundOpen(false);
            websockets_sidecar_1.websockets.joinChannel(c.key, false, false, '');
        }));
    });
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var addText = function (text, x, y) {
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3);
        obj.texts.push(_text);
        return _text;
    };
    g.clear();
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    g.fillStyle(0x222222, 0.67);
    g.fillRect(0, 0, gb.width, gb.height);
    var w = obj.targetWidth;
    var h = obj.targetHeight;
    var x = (gb.width - w) / 2;
    var y = (gb.height - h) / 2;
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h);
    addText('Open games', x + 6, y);
    // let textDesc = addText(obj.textDesc, x + 6 + 20, y + 40)
    // stevieTexts2.setWrapWidth(textDesc, obj.targetWidth - 50)
    x += 20;
    y += h - 60;
    obj.buttons[0].x = x;
    obj.buttons[0].y = y;
    obj.buttons[1].x = x + 200;
    obj.buttons[1].y = y;
    obj.buttons[1].text = obj.isRefreshing ? 'Refreshing...' : 'Refresh';
    x = (gb.width - w) / 2 + 20;
    y = (gb.height - h) / 2 - 20;
    imports_1.l.forEach(obj.buttons, function (c, cIdx) {
        if (cIdx <= 1) {
            return;
        }
        y += 50;
        c.x = x;
        c.y = y;
    });
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var setOpen = function (isOpen, onOk) {
    if (onOk === void 0) { onOk = function () { }; }
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    obj.isRefreshing = isOpen;
    // obj.onOk = onOk
    if (isOpen) {
        exports.update();
    }
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        if (obj.isRefreshing) {
            if (websockets_sidecar_1.websockets.isStillConnecting()) {
                obj.isRefreshing = true;
            }
            else {
                websockets_sidecar_1.websockets.refreshGameList();
                obj.isRefreshing = false;
            }
        }
        var list = websockets_sidecar_1.websockets.getGameList();
        if (obj.lastListLength !== list.length) {
            obj.lastListLength = list.length;
            createButtons();
        }
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        render();
        clickEater_sidecar_1.clickEater.tempEatCursor();
    }
    else {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    }
};
exports.update = update;
